// conductor-emit-hash: 47adcbe0
// generated by pbo-conductor — 코드관리 (sy07)
// conductor-build: 75fb504a 2026-09-21T12:13:45.227Z · pbo-core 0.8.2
// dev 위치: pages/master/commonCode
// 데이터 seam: useCommonCodeList — TODO(dev): 목데이터를 이 훅으로 교체
//
// 그룹 규격 — 이 화면이 쓰는 공통 조합의 계약(컨덕터 소유).
//   이 값을 벗어나면 컨덕터 데모와 어긋납니다. 규격을 바꾸려면 컨덕터에서 바꾸세요.
//   ⚠️ 그룹은 화면마다 사본으로 나갑니다 — 여기서 고쳐도 다른 화면은 바뀌지 않습니다.
//   titleRow #0d760c
//     · title(제목) — 자유 입력
//     · backRoute(뒤로가기 라우트) — 자유 입력
//     · notice(제목 옆 안내 문구) — 자유 입력
//     · stickyTop(스티키 멈춤 위치(px)) 제한 없음 [기본 12]
//     · buttonSize(타이틀 버튼 크기) = S | M | L [기본 L]
//     · 제목 옆 컨트롤과 우측 액션은 자리를 섞지 않는다 — 컨텍스트(센터·뷰)는 제목 옆, 행위는 우측 끝
//   filterCard #e70a16
//     · platform(배치 규약(desktop 라벨 위·3~4열 / moss 라벨 왼쪽·항상 3열)) = desktop | moss [기본 desktop]
//     · searchText(조회 버튼 문구) — 자유 입력
//     · resetText(초기화 버튼 문구) — 자유 입력
//     · defaultCollapsed(진입 시 접힘) = 켬 | 끔 [기본 false]
//     · summaryMessage(요약 카드 아래 안내 문구(summary 슬롯 있을 때)) — 자유 입력
//     · cols(한 줄 항목 수(moss)) 3~3개
//     · colGap(항목 가로 간격(moss)) 제한 없음
//     · rowGap(줄 세로 간격(moss)) 제한 없음
//     · labelWidth(라벨 칸 고정폭(moss)) 제한 없음
//     · labelGap(라벨-값 간격(moss)) 제한 없음
//     · itemMaxWidth(필터 항목 최대 폭) ≤ 420px [기본 420px]
//     · itemsPerRow(한 줄 항목 수) 3~4개 [기본 4개]
//     · collapsedShows(접었을 때 노출) = 값이 있는 항목만 | 전부 [기본 값이 있는 항목만]
//     · twoColBreakpoint(2단 필드 칩 접힘 폭) 제한 없음 [기본 320px]
//     · valueMinWidth(값 컨트롤 최소 폭) 제한 없음 [기본 240px]
//     · typeMinWidth(유형 셀렉트 최소 폭) 제한 없음 [기본 88px]
//     · typeMaxWidth(유형 셀렉트 최대 폭) 제한 없음 [기본 120px]
//     · 필터 항목 width는 max 420px 해상도에 따라 조절
//     · 한 줄에 필터 항목 3개부터 최대 4개까지 노출.
//     · 필터 접기 시, 값이 있는 필터만 노출
//     · 필터 접기 시, 값이 전부 없는 경우 문구 노출.
//   tableGroup #7b6f57
//     · pagerVariant(페이저 표기) = paged | range [기본 paged]
//     · pager(페이저 노출) = 켬 | 끔 [기본 true]
//     · listSearch(목록 검색 노출) = 켬 | 끔 [기본 true]
//     · pagerSizeChanger('몇개씩' 노출) = auto | hide [기본 auto]
//     · rightFirst(화면 우측 요소를 표준 앞에) = 켬 | 끔 [기본 false]
//     · leadColumns(선두 컬럼) = 체크박스 → No | No | 없음 [기본 체크박스 → No]
//     · checkboxWidth(체크박스 폭) 제한 없음 [기본 48px]
//     · noWidth(No 폭) 제한 없음 [기본 48px]
//     · 값·말줄임 짤림 금지 — 컬럼 폭은 콘텐츠 맞춤
//     · 엑셀 다운로드는 exportColumns(한글 헤더) 지정
//
import { core } from '@musinsa/pbo-core'
import { pboLogisticsTheme } from '@musinsa/pbo-core/theme'
import '@musinsa/pbo-core/tokens.css'
import '@musinsa/pbo-core/styles.css'
import '@musinsa/pbo-core/fonts.css'
import '../screenShell.css'
import { type ComponentProps, type ReactNode, useEffect, useMemo, useRef, useState } from 'react'
import { DownOutlined, UpOutlined } from '@ant-design/icons'
import { Icon as DsIcon } from '@musinsa/pbo-assets'
import { usePageHeaderSticky } from '../pageHeaderSticky'
import type { ButtonCode, ToolbarConfig } from '@/services/auth/menu.types'

// 컴포넌트 모드(문서 51) — 이 파일은 겉(UI)만이다. 배선(Wiring)은 화면 엔트리(개발자 소유)가 props 로 넘긴다 — 옛 훅·API·핸들러를 그대로 쓰면 된다.
//  모듈 홀더: 확인창 함수·선택 게이트 등 모듈 수준 코드가 같은 배선을 보도록 렌더 첫머리에서 갱신한다. props.wiring 은 렌더마다 새 객체여도 된다(효과 의존성에 쓰지 않는다).
let wiring: Wiring = { rows: {}, actions: {} } as Wiring
// 버튼 권한 슬롯(LOGISPRD-16733) — 슬롯이 없으면 전부 보이고 편집된다.
const permCan = (code: ButtonCode) => wiring.permission?.canShow(code) ?? true
// table = 표 id(columnLayout 키) — 그 표의 화면관리 그리드 설정(LOGISPRD-17249). 없으면 메뉴 단위 값.
const permSlot = (table?: string) => (table ? wiring.permission?.forTable?.(table) : undefined) ?? wiring.permission
const permTool = (key: keyof ToolbarConfig, table?: string) => permSlot(table)?.toolbar[key] ?? true
const permCols = (columns: core.CoreColumnType[], table?: string) => permSlot(table)?.columns(columns) ?? columns

/** 배선 계약(문서 50) — wiring.ts(개발자 소유)가 이 타입을 채운다. 이름은 노드 id·상수명에서 기계적으로 나온다.
 *  화면(이 파일)은 재핸드오프 때 통째로 덮어쓴다 — 계약이 바뀌면 dev tsc 가 wiring.ts 의 그 자리를 가리킨다. */
export type Row = Record<string, unknown>
/** 표 슬롯 인자 — filters = 같은 화면 조회영역 값(키 = filterKey/노드 id) · pager = 액션바 페이저(page 1부터, size). 없는 화면은 undefined. */
export type RowsQuery = { filters?: Record<string, unknown>; pager?: { page: number; size: number } }
/** 액션 슬롯 인자 — selected = 같은 core.TableSelectionScope 안 표의 선택 행(체크박스). 선택 표가 없는 화면은 빈 배열. */
export type ActionCtx = { selected: Row[]; visible?: Row[]; form?: FormState } // selected = 체크 선택 행 · visible = 목록 검색 뒤 화면에 보이는 행(표가 여럿이면 마지막 표, 검색칸 없는 화면은 없음) · form = 확인을 누른 모달의 폼 값(폼 스토어가 있는 모달만)
/** 폼 버스 상태(모달·카드의 입력 값). 조건(hideWhen 등)은 wiring.form.<store> 가 덮어쓴 유효 상태를 본다. */
export type FormState = Record<string, unknown>
/** 선택지(옵션) — value 는 API/코드 값, label 은 표시 문구. 조회영역·모달 셀렉트/라디오는 숫자 value 도 쓴다. */
export type Option = { value: string | number; label: string }
/** 편집 셀 셀렉트의 선택지 — DS 셀 계약(variantProps.options)이 value 를 문자열로만 받는다. */
export type CellOption = { value: string; label: string }
/** 표 컬럼 배치(2026-10-21) — DS core.Table 의 제어형 prop 그대로. 컬럼 id = dataIndex(재핸드오프로 dataIndex 가 바뀌면 그 컬럼 저장값은 무시된다).
 *  순서·너비는 조절한 것만 와도 된다. 초기화는 []/{} (undefined 로 바꾸면 비제어로 돌아가 직전 내부 상태가 남는다). */
export type ColumnLayout = Pick<core.CoreTableProps, 'columnOrder' | 'onColumnOrderChange' | 'columnWidths' | 'onColumnWidthsChange' | 'pinnedColumns' | 'onPinnedColumnsChange' | 'hiddenColumns' | 'onHiddenColumnsChange'>
export type Wiring = {
  /** 표 데이터 — 인자는 데모 목데이터(자리 표시)와 조회 조건·페이저. 컴포넌트 본문 첫머리에서 항상 같은 순서로 불리므로 안에서 조회 훅을 써도 된다.
   *  배열을 돌려주면 클라이언트 페이징(데모와 같음), { rows, total } 을 돌려주면 서버 페이징(표는 그대로 그리고 카운트·페이저는 total). */
  rows: { ROWS: (demo: Row[], q: RowsQuery) => Row[] | { rows: Row[]; total?: number; loading?: boolean } }
  /** 동작 — 조회(search)·버튼·확인창·모달 확인·편집 셀·행 버튼. 실패는 throw(확인창·모달이 열린 채 남는다). 성공 토스트·닫기는 생성본이 한다. */
  actions: { search: (filters: Record<string, unknown>) => void | false | Promise<void | false>; sy07AddButton: (ctx: ActionCtx & { table: string; defaults: Record<string, unknown> }) => void; ROWS_rowsChange: (rows: Record<string, unknown>[]) => void; sy07SaveConfirm_ok: (ctx: ActionCtx) => void | string | false | Promise<void | string | false>; sy07DeleteConfirm_ok: (ctx: ActionCtx) => void | string | false | Promise<void | string | false> }
  /** 요청 진행 중 여부(React 훅) — true 면 선택 게이트 버튼(확정·삭제·저장 등)이 잠긴다. 선택 게이트 버튼이 매 렌더 부르므로 안에서 훅을 써도 된다(예: react-query useIsMutating() > 0). 없으면 잠그지 않는다. */
  useBusy?: () => boolean
  /** 표 체크 선택이 바뀔 때 — 상세 표가 선택을 따라가는 화면(마스터-디테일)에서 배선이 그 키로 상세를 조회한다.
   *  선택이 있는 스코프만 알린다(위아래 표에서 빈 스코프가 덮지 않게). 액션 슬롯의 ctx.selected 와 같은 값이다.
   *  scope = **그 선택이 어느 표 그룹의 것인지**(그룹 노드 id). 위아래 표가 있는 화면은 이것으로 갈라 둔다 —
   *  선택을 **푼** 신호는 rows 가 빈 배열이라 행만 보고는 어느 표인지 알 수 없다(2026-09-21 est01). */
  onSelect?: (rows: Row[], scope: string) => void
  /** 페이지를 옮기기 **전** 물어본다 — false 를 주면 옮기지 않는다(미저장 편집 보호 등, 옛 손코드의 window.confirm 자리).
   *  onState 는 **이미 바뀐 뒤** 통지라 되돌릴 수 없다 — 막아야 하는 것은 여기서 막는다. 없으면 그냥 옮긴다. */
  canChangePage?: (next: { pager: string; page: number; size: number }) => boolean
  /** [초기화] 때 — 저장된 조회 조건(URL/세션)과 조회 결과도 지운다(옛 손코드 handleFilterReset). 생성본은 조회영역 값·페이저·선택·목록 검색어를 되돌린다. 없으면 화면 값만. */
  onReset?: () => void
  /** 화면 상태(페이저·목록 검색어) 진입 초기값 — 동기 함수 아님, 값(예: URL 복원). 없으면 데모 기본값(1페이지·빈 검색어). */
  stateInitial?: { pager?: { "pager"?: { page?: number; size?: number } }; listq?: { "table.q"?: string } }
  /** 화면 상태가 바뀔 때(페이지 이동·검색어 확정·조회 초기화) — 배선이 URL/세션에 싣는다(옛 손코드 page/keyword persist). */
  onState?: (s: { pager: { "pager": { page: number; size: number } }; listq: { "table.q": string } }) => void
  /** 모달 열기 전 가드 — 버튼 클릭 때 선택 행(ctx.selected)으로 부른다. false 를 돌려주면 열지 않는다(왜 못 여는지는 배선이 토스트로). 없으면 그냥 연다. */
  opens?: { sy07SaveButton?: (ctx: ActionCtx) => boolean; sy07DeleteButton?: (ctx: ActionCtx) => boolean }
  /** 옵션 — 조회영역 셀렉트·라디오·편집 셀 셀렉트의 선택지. 인자는 데모 옵션(자리 표시). 컴포넌트 첫머리에서 항상 같은 순서로 불리므로 안에서 조회 훅(콤보 API 등)을 써도 된다.
   *  데모는 value=label 목데이터라, API 로 바꾸면(예: 화주 = 코드) 조회 조건·저장 값도 그 value 로 나간다 — 조회 기본값은 filterDefaults 로 같이 맞출 것.
   *  조회영역 옵션은 두 번째 인자로 **현재 조회영역 값**을 받는다(예: 화주유형 → 그 유형의 화주명만). */
  options?: { SY07SHIPPER_OPTIONS?: (demo: Option[], filters?: Record<string, unknown>) => Option[] }
  /** 조회 조건 기본값 — 데모 기본값(예: 화주명 "무신사스탠다드")을 실값(예: 로그인 사용자 화주 코드)으로 덮어쓴다. **동기 함수**(훅 금지 — useMemo 안에서 한 번 계산). */
  filterDefaults?: { sy07FilterCard?: (demo: Record<string, unknown>) => Record<string, unknown> }
  /** 진입 초기값 — 기본값 위에 URL/세션 복원값을 얹는다(동기 함수). [초기화] 는 여기 값이 아니라 filterDefaults 로 돌아간다. */
  filterInitial?: { sy07FilterCard?: (defaults: Record<string, unknown>) => Record<string, unknown> }
  /** 늦게 오는 기본값 — 옵션(화주 목록 등)이 도착한 뒤 **비어 있는** 조회 조건을 채운다(예: 세션 화주가 없으면 첫 화주). 인자 = 현재 조회영역 값 · 조회영역 옵션들(슬롯명 = 키). 옵션 배열이 바뀔 때마다·[초기화] 뒤에 다시 부른다. 값이 있는 키는 덮지 않는다. 동기 함수. */
  filterFallback?: { sy07FilterCard?: (current: Record<string, unknown>, options: Record<string, Option[]>) => Record<string, unknown> | void }
  /** 조회영역 칸 잠금 — 키 = 조회 조건 키(filterKey). true 면 그 칸을 비활성으로 그린다(예: 화주 고정 계정의 화주명).
   *  값은 잠그지 않는다 — 잠긴 칸의 값은 filterDefaults 로 넣고, 조회 슬롯에서도 서버로 나가는 값을 직접 고정할 것. */
  filterDisabled?: { SPR_NM?: boolean }
  /** 표 컬럼 배치(2026-10-21, LOGISPRD-15649) — 사용자가 바꾼 순서·너비·고정·숨김을 배선이 저장·복원한다(예: 사용자·화주별 서버 저장).
   *  키 = 표 노드 id(재핸드오프로 표가 늘어도 밀리지 않는다). 함수 — 매 렌더 같은 자리에서 불리므로 안에서 저장 훅을 써도 된다.
   *  인자 columns = 그 표에 넘기는 컬럼 정의(정의 순서·기본 fixed) — 콜백은 바뀐 컬럼만 주므로 전체 상태 저장·고정 해제 복원에 쓴다.
   *  표에 따라 렌더마다 새 배열이다(본문 상수) — effect·memo 의존성에는 배열 대신 내용(dataIndex·fixed 목록)을 쓴다.
   *  없거나 그 표 키가 없으면 종전대로 표 내부 상태(저장 안 함). */
  columnLayout?: { "sy07Table"?: (columns: core.CoreColumnType[]) => ColumnLayout }
  /** 버튼 권한(LOGISPRD-16733) — 메뉴 API 의 버튼 권한 계산 결과. 없으면 전부 보이고 편집된다(지금 동작).
   *  canShow = code 가 붙은 버튼 노출 · toolbar = 엑셀 업로드·다운로드 등 툴바 버튼 · editable = false 면 [일괄 입력]을 숨긴다 ·
   *  columns = 표 컬럼(잠금이면 편집 셀을 글자로 바꿔 돌려준다 — 채우기·Delete·타이핑도 함께 막힌다). */
  permission?: { canShow: (code: ButtonCode) => boolean; toolbar: ToolbarConfig; editable: boolean; columns: (columns: core.CoreColumnType[]) => core.CoreColumnType[]; bulk?: <T extends { key: string }>(items: T[]) => T[]; forTable?: (table: string) => { toolbar: ToolbarConfig; columns: (columns: core.CoreColumnType[]) => core.CoreColumnType[]; bulk?: <T extends { key: string }>(items: T[]) => T[] } }
}

// ⚠ 그룹 cmp.TitleRow #sy07Title 인스턴스 prop 무시: align, justify, titleSticky — 정의(마커·propsSchema)에 없어 데모도 그리지 않는다(옛 노드 시절 잔재). 정리는 컨덕터 저장본에서.
const SY07SHIPPER_OPTIONS_DEMO: Option[] = [{"label":"무신사스탠다드","value":"무신사스탠다드"},{"label":"무신사","value":"무신사"},{"label":"29CM","value":"29CM"},{"label":"글로벌세일즈","value":"글로벌세일즈"}]
// 조회 조건 기본값(데모) — 옵션을 API 로 바꾸면(예: 화주 = 코드) wiring.filterDefaults.sy07FilterCard 가 같은 키를 그 value 로 덮어쓴다(예: 로그인 사용자 화주 코드).
const flSy07FilterCardDefaults_DEMO: Record<string, unknown> = { SPR_NM: "무신사스탠다드" }
// ⚠ 그룹 cmp.FilterCard #sy07FilterCard 인스턴스 prop 무시: bodyPadding, filterFrame — 정의(마커·propsSchema)에 없어 데모도 그리지 않는다(옛 노드 시절 잔재). 정리는 컨덕터 저장본에서.
const COLUMNS: core.CoreColumnType[] = [{"title":"화주코드","width":160,"variant":"input","required":true,"dataIndex":"SPR_NM"},{"title":"코드그룹","width":180,"variant":"input","required":true,"dataIndex":"CODE_GRP"},{"title":"코드","width":180,"variant":"input","required":true,"dataIndex":"CODE"},{"title":"코드내용","width":260,"variant":"input","required":true,"dataIndex":"CODE_DESC"},{"title":"생성일시","width":150,"dataIndex":"INS_DATE"},{"title":"생성자","width":110,"dataIndex":"INS_BY"},{"title":"수정일시","width":150,"dataIndex":"UPD_DATE"},{"title":"수정자","width":110,"dataIndex":"UPD_BY"}]
// TODO(api): ROWS 는 데모 목데이터 10행 중 앞 5행 — 실제 데이터로 교체(전체 표본은 패키지 data-requirements.json)
const ROWS_DEMO: Record<string, unknown>[] = [{"CODE":"PARCEL","INS_BY":"시스템","SPR_NM":"공통","UPD_BY":"나형진","CODE_GRP":"TRS_TYPE","INS_DATE":"2025-11-02 09:14","UPD_DATE":"2026-03-14 16:52","CODE_DESC":"택배"},{"CODE":"TRUCK","INS_BY":"시스템","SPR_NM":"공통","UPD_BY":"시스템","CODE_GRP":"TRS_TYPE","INS_DATE":"2025-11-02 09:14","UPD_DATE":"2025-11-02 09:14","CODE_DESC":"용차"},{"CODE":"EXPRESS","INS_BY":"시스템","SPR_NM":"공통","UPD_BY":"심현아","CODE_GRP":"TRS_TYPE","INS_DATE":"2025-11-02 09:15","UPD_DATE":"2026-01-20 11:08","CODE_DESC":"특송"},{"CODE":"NORMAL","INS_BY":"시스템","SPR_NM":"공통","UPD_BY":"시스템","CODE_GRP":"ORD_TYPE","INS_DATE":"2025-11-02 09:15","UPD_DATE":"2025-11-02 09:15","CODE_DESC":"일반"},{"CODE":"RETURN","INS_BY":"시스템","SPR_NM":"공통","UPD_BY":"시스템","CODE_GRP":"ORD_TYPE","INS_DATE":"2025-11-02 09:16","UPD_DATE":"2025-11-02 09:16","CODE_DESC":"반품"}]
// 걸러진 행 브리지 — 액션 슬롯 인자(ctx.visible). 목록 검색을 거친 뒤 화면에 보이는 행(표가 여럿이면 마지막 표).
const visRef: { current: Record<string, unknown>[] } = { current: [] }
// TODO(dev): ROWS 행 key — wiring.rows 가 행에 key(BE 행 id)를 실으면 그것이 쓰인다(스프레드가 인덱스를 덮는다). 안 실으면 배열 인덱스라 재조회·페이지 이동 뒤 체크 선택이 다른 행에 붙는다. 행 고유 필드(BE 행 id)를 rowKey 로(컨덕터 표 속성 rowKey 지정 시 자동) — 또는 wiring.rows 가 행에 key 를 실으면 스프레드가 인덱스를 덮어 그 값이 쓰인다.
const confirmsy07SaveConfirm = () =>
  core.Modal.confirm({
    icon: <span style={{ display: 'inline-flex', lineHeight: 0, marginInlineEnd: 12 }}><DsIcon name="ic-alertCircle" size={22} color="#faad14" filled /></span>,
    title: "알림",
    content: fillTok("선택한 {count}건의 코드를 저장하시겠습니까?"),
    okText: "확인",
    cancelText: "취소",
    onOk: async () => {
      const okMsg = fillTok("{count}건 저장 완료")
      const okRes = await wiring.actions.sy07SaveConfirm_ok(selCtx())
      if (okRes !== false) core.message.success(typeof okRes === 'string' ? okRes : okMsg)
      selReset.current()
    },
  })
const confirmsy07DeleteConfirm = () =>
  core.Modal.confirm({
    icon: <span style={{ display: 'inline-flex', lineHeight: 0, marginInlineEnd: 12 }}><DsIcon name="ic-alertCircle" size={22} color="#faad14" filled /></span>,
    title: "알림",
    content: fillTok("선택한 {count}건의 코드를 삭제하시겠습니까?"),
    okText: "삭제",
    cancelText: "취소",
    okButtonProps: { danger: true },
    onOk: async () => {
      const okMsg = fillTok("{count}건 삭제 완료")
      const okRes = await wiring.actions.sy07DeleteConfirm_ok(selCtx())
      if (okRes !== false) core.message.success(typeof okRes === 'string' ? okRes : okMsg)
      selReset.current()
    },
  })
// 선택 행 브리지 — 액션 슬롯 인자(ctx.selected). 같은 core.TableSelectionScope 안 표의 체크 선택 행(SelBridge 가 채운다). 한 화면에 스코프가 여럿이면 마지막으로 바뀐 스코프의 선택이다.
const selRef: { current: Record<string, unknown>[] } = { current: [] }
// 확인창(모듈 함수) 성공 뒤 표 선택 비우기 — 컴포넌트가 마운트 동안 setter 를 꽂는다(스코프가 없으면 no-op)
const selReset: { current: () => void } = { current: () => {} }
const selCtx = (): ActionCtx => ({ selected: selRef.current, visible: visRef.current })
// 문구 토큰 — 어댑터 규약 미러(selectionTokens.ts): {count} = 표 선택 수(호출 시점), {<컬럼>} = 선택 행의 그 컬럼 값(중복 제거 · 여럿이면 "첫 값 외 n건" · 키는 대소문자 무시, 없으면 빈 문자열).
//  값은 **원본 행**(origRows = wiring.rows 가 준 행, 편집 셀 반영 전)에서 읽는다 — 편집만 하고 저장 안 한 값이 확인 문구에 보이면 실제 삭제·확정 대상(원본 식별자)과 어긋난다.
const origRows = new Map<string, Record<string, unknown>[]>()
// (옛 문구 자리)
const fillTok = (s: string): string => s.replace(/\{(\w+)\}/g, (_m, k: string) => {
  const all = [...origRows.values()].flat()
  const rows = selRef.current.map((r) => all.find((o) => o.key === r.key) ?? r)
  if (k === 'count') return String(rows.length)
  const first = rows[0]
  const key = first ? (k in first ? k : Object.keys(first).find((c) => c.toLowerCase() === k.toLowerCase())) : undefined
  const vals = key ? [...new Set(rows.map((r) => r[key]).filter((v) => v != null && v !== '').map(String))] : []
  return vals.length > 1 ? `${vals[0]} 외 ${vals.length - 1}건` : (vals[0] ?? '')
})

const POPUP_DOWN = {
  bottomLeft: { points: ['tl', 'bl'], offset: [0, 4], overflow: { adjustX: true, adjustY: false } },
  bottomRight: { points: ['tr', 'br'], offset: [0, 4], overflow: { adjustX: true, adjustY: false } },
}

const filterFieldClass = (key: string): string => `pbo-ff--${key.replace(/[^A-Za-z0-9_-]/g, '_')}`
const FILTER_FOCUSABLE = 'input:not([type=hidden]):not([disabled]), textarea:not([disabled]), [contenteditable=true], button:not([disabled])'
const FILTER_OPEN_EVENTS = ['pointerdown', 'mousedown', 'mouseup', 'click'] as const
const openFilterField = (open: () => void, key: string) => {
  open()
  window.setTimeout(() => {
    const frame = document.querySelector(`.${filterFieldClass(key)}`)
    if (!frame) return
    frame.querySelector<HTMLElement>(FILTER_FOCUSABLE)?.focus()
    // 고른 항목을 바로 고칠 수 있게 목록·달력까지 펼친다 — antd 는 포커스만으로 열지 않는다(셀렉트=selector, 날짜=입력이 받는다).
    const host = frame.querySelector<HTMLElement>('.ant-select-selector') ?? frame.querySelector<HTMLElement>('.ant-picker input')
    if (!host) return
    // forEach — dev 레포 ESLint(no-restricted-syntax)가 for…of 를 막는다(2026-09-19 dry 실측).
    FILTER_OPEN_EVENTS.forEach((type) => host.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window })))
  }, 0)
}

const chipText = (v: unknown): string | null => (typeof v === 'string' && v.trim() ? v : null)

const chipSelect = (opts: Option[], v: unknown, required?: boolean): string | null =>
  v == null || v === '' ? (required ? '전체' : null) : (opts.find((o) => o.value === v)?.label ?? String(v as string | number))

/** 조회영역 필드 프레임(그룹 cmp.FilterField) — 접힘이면 값 칩(값 없으면 숨김), 열림이면 DS FormItem(라벨 위). 규격 = pbo-core filter-layout.css .pbo-filter-field */
function FilterField({ collapsed, label, required, tooltip, width, chip, fieldKey, onOpen, children }: { collapsed: boolean; label?: string; required?: boolean; tooltip?: string; width?: number | string; chip?: string | null; fieldKey?: string; onOpen?: () => void; children?: ReactNode }) {
  if (collapsed) {
    // 칩을 누르면 조회영역이 열리고 그 항목으로 포커스가 간다(전 화면 공통).
    const open = fieldKey && onOpen ? () => openFilterField(onOpen, fieldKey) : undefined
    return (
      <div
        className="pbo-filter-closed"
        hidden={chip == null}
        {...(open
          ? {
              role: 'button',
              tabIndex: 0,
              style: { cursor: 'pointer' }, // 규격 CSS 는 칩을 읽기 전용으로 본다 — 누를 수 있다는 표시만 여기서
              onClick: open,
              onKeyDown: (e: { key: string; preventDefault: () => void }) => {
                if (e.key !== 'Enter' && e.key !== ' ') return
                e.preventDefault()
                open()
              },
            }
          : {})}
      >
        {label ? (
          <div className="pbo-filter-chip-label">
            <label>{label}</label>
            {required ? <span className="pbo-filter-req">*</span> : null}
          </div>
        ) : null}
        <div className="pbo-filter-chip-value">{chip}</div>
      </div>
    )
  }
  return (
    <core.FormItem className={fieldKey ? `pbo-filter-field ${filterFieldClass(fieldKey)}` : 'pbo-filter-field'} label={label} required={required} tooltip={!!tooltip} tooltipText={tooltip} labelPosition="top" boxedItem={false} style={width != null ? { width } : undefined}>
      {children}
    </core.FormItem>
  )
}

/** 요청 진행 중(선택 게이트 잠금) — wiring.useBusy 훅(없으면 항상 false). 훅이라 렌더마다 최신값이다(예: react-query useIsMutating) — 모듈 변수를 effect 에서 대입하면 한 렌더 늦게 보인다. */
const noBusy = (): boolean => false
/** 선택 0개면 비활성 — 같은 core.TableSelectionScope 안의 표 선택 개수를 읽는다(DS 훅). 스코프 밖이면 항상 비활성. 요청 중(useBusy)에도 잠긴다.
 *  useBusy 는 호출 때 읽는다(모듈 평가 때 잡아 두면 컴포넌트 모드의 홀더 갱신을 못 본다). */
function SelGatedButton({ disabled, ...rest }: ComponentProps<typeof core.Button>) {
  const n = core.useTableSelectionCount()
  const busy = (wiring.useBusy ?? noBusy)()
  return <core.Button {...rest} disabled={disabled || (n ?? 0) === 0 || busy} />
}

/**
 * 편집 시 자동 체크 표 — 셀을 고친 행을 체크 선택에 더한다(1.0 CommonUtil.onCellValueChanged 의 setSelected(true) 미러).
 * 같은 표 묶음의 [저장] 이 체크한 행만 보내는 화면에서, 고치고 체크를 잊어 저장이 꺼진 채 남거나 고친 행이 빠지는 것을 막는다.
 * core.Table 을 그대로 감싼다(프롭 동일). 사람이 바꾼 선택은 그대로 따르고, 상위가 selectedRowKeys 를 주면(업로드 뒤 전체 선택) 그 값에 더해 onChange 로 올린다.
 * 고친 행 = 받은 dataSource 와도 직전 onRowsChange 와도 다른 행(편집을 dataSource 에 되먹이지 않는 배선에서 사람이 푼 체크가 되살아나지 않게).
 * 행 수가 바뀐 변경(삭제 열)은 편집이 아니라 건너뛴다. 선택은 스코프 key(선택 epoch)가 바뀌어 다시 마운트될 때 비워진다.
 */
function EditSelTable<T extends Record<string, unknown>>({ rowSelection, onRowsChange, dataSource, ...rest }: Parameters<typeof core.Table<T>>[0]) {
  const [inner, setInner] = useState<React.Key[]>([])
  const keys = rowSelection?.selectedRowKeys ?? inner
  // 미뤄 둔 반영이 견줄 최신 선택 — 편집 시점의 keys 로 합치면 그 사이 사람이 바꾼 체크를 덮는다(데모 setKeys((cur) => …) 와 같은 결과).
  const cur = useRef(keys)
  cur.current = keys
  const last = useRef<T[] | null>(null)
  const keyField = typeof rest.rowKey === 'string' ? rest.rowKey : 'key'
  const keyOf = (r: T, i: number): React.Key => (r[keyField] as React.Key | undefined) ?? i
  const same = (a: T, b: T) => a === b || [...new Set([...Object.keys(a), ...Object.keys(b)])].every((k) => Object.is(a[k], b[k]))
  const edited = (next: T[]): React.Key[] => {
    const source = dataSource ?? []
    if (next.length !== source.length) return []
    const index = (rs: readonly T[]) => new Map(rs.map((r, i) => [String(keyOf(r, i)), r]))
    const src = index(source)
    const prev = last.current && last.current.length === next.length ? index(last.current) : null
    return next.flatMap((r, i) => {
      const k = keyOf(r, i)
      const a = src.get(String(k))
      if (!a || same(a, r)) return []
      const b = prev?.get(String(k))
      return b && same(b, r) ? [] : [k]
    })
  }
  return (
    <core.Table<T>
      {...rest}
      dataSource={dataSource}
      rowSelection={rowSelection && {
        ...rowSelection,
        selectedRowKeys: keys,
        onChange: (k, rows, info) => {
          setInner(k)
          cur.current = k
          rowSelection.onChange?.(k, rows, info)
        },
      }}
      onRowsChange={(next) => {
        const added = edited(next)
        last.current = next
        onRowsChange?.(next)
        if (!added.length) return
        // DS 표는 onRowsChange 를 자기 상태 갱신 함수 안에서 부른다 — 곧장 이 컴포넌트를 갱신하면 렌더 중 갱신 경고라 한 박자 미룬다.
        queueMicrotask(() => {
          const have = new Set(cur.current.map(String))
          const extra = added.filter((k) => !have.has(String(k)))
          if (!extra.length) return
          const merged = [...cur.current, ...extra]
          const set = new Set(merged.map(String))
          cur.current = merged
          setInner(merged)
          rowSelection?.onChange?.(merged, next.filter((r, i) => set.has(String(keyOf(r, i)))), { type: 'multiple' })
        })
      }}
    />
  )
}

/** 표 카운트 — 같은 core.TableSelectionScope 안 표의 선택 개수를 '선택 N / 전체' 로 함께 그린다(데모 TableStatRender 와 같은 규약). 스코프 밖이면 전체만. */
function SelStat(props: ComponentProps<typeof core.TableStat>) {
  const n = core.useTableSelectionCount()
  return <core.TableStat {...props} selectedCount={n && n > 0 ? n : undefined} />
}

/**
 * 선택 행 브리지(문서 50 슬롯 2차) — 같은 core.TableSelectionScope 안 표의 선택 행을 모듈 변수 selRef 로 흘려 보낸다.
 * 액션 슬롯이 ctx.selected 로 받고, 배선이 wiring.onSelect 로 같은 값을 구독한다(상세 표가 선택을 따라가는 화면).
 *
 * 한 화면에 스코프가 여럿이면(위아래 표) **선택이 있는 스코프만** selRef 를 쓴다 — 선택 표가 없는 스코프가
 * 빈 배열로 덮으면 다른 표의 선택이 사라진다(2026-09-19 gl11 위아래 표에서 발견).
 *
 * scope = 이 스코프를 연 그룹 노드 id. 선택을 **푼** 신호는 rows 가 빈 배열이라 행만 보고는 어느 표인지
 * 알 수 없다 — 배선이 위아래를 갈라 두려면 이 값이 있어야 한다(2026-09-21 est01).
 */
function SelBridge({ scope }: { scope: string }) {
  const s = core.useTableSelection()
  const rows = s?.rows
  const owned = useRef(false)
  useEffect(() => {
    if (rows?.length) {
      owned.current = true
      selRef.current = rows
      wiring.onSelect?.(rows, scope)
    } else if (owned.current) {
      owned.current = false
      selRef.current = []
      wiring.onSelect?.([], scope)
    }
    return () => { // 언마운트·스코프 이탈 때 비운다(모듈 변수라 다음 인스턴스로 새지 않게, #772 봇)
      if (!owned.current) return
      owned.current = false
      selRef.current = []
    }
  }, [rows, scope]) // scope 는 그룹 id 리터럴이라 실제로 안 바뀌지만 exhaustive-deps 규칙상 넣는다(moms-fe #787 봇)
  return null
}

export default function CommonCodePageView(props: { wiring: Wiring }) {
  wiring = props.wiring // 모듈 홀더 갱신 — 렌더마다 같은 참조
  const hdrsy07Title_titleRowDef = usePageHeaderSticky()
  // 조회영역 값 버스(그룹 #sy07FilterCard) — 각 필드가 filterKey(없으면 노드 id)를 키로 값을 올린다. [초기화]는 기본값으로 되돌리고 토큰을 올려
  //  모든 필드를 기본값으로 되돌린다(DS resetToken 계약). [조회]는 이 객체를 그대로 쿼리 조건으로 쓴다.
  const flSy07FilterCardDefaults = useMemo(() => (wiring.filterDefaults?.sy07FilterCard ?? ((d: Record<string, unknown>) => d))(flSy07FilterCardDefaults_DEMO), []) // 조회 조건 기본값 — wiring.filterDefaults 슬롯(동기). [초기화] 가 돌아가는 값
  const flSy07FilterCardDefaultsInitial = useMemo(() => (wiring.filterInitial?.sy07FilterCard ?? ((d: Record<string, unknown>) => d))(flSy07FilterCardDefaults), []) // 진입 초기값 — wiring.filterInitial 슬롯(동기, 예: URL 복원). 없으면 기본값
  const [flSy07FilterCard, setFlSy07FilterCard] = useState<Record<string, unknown>>(flSy07FilterCardDefaultsInitial)
  const [flSy07FilterCardReset, setFlSy07FilterCardReset] = useState(0)
  // 조회영역 접기(그룹 #sy07FilterCard) — 닫히면 필드가 값 칩으로 바뀌고 [필터 열기] 로 되돌린다(규격 CSS .pbo-filter-collapse-*).
  const [flSy07FilterCardCollapsed, setFlSy07FilterCardCollapsed] = useState(false)
  const SY07SHIPPER_OPTIONS = wiring.options?.SY07SHIPPER_OPTIONS ? wiring.options.SY07SHIPPER_OPTIONS(SY07SHIPPER_OPTIONS_DEMO, flSy07FilterCard) : SY07SHIPPER_OPTIONS_DEMO // 옵션 — wiring.options 슬롯(두 번째 인자 = 현재 조회영역 값)
  const [stSelEpoch, setStSelEpoch] = useState(0) // 토글 상태(스토어 키 'selEpoch')
  useEffect(() => { // 옵션이 늦게 도착한 뒤 비어 있는 조회 조건을 채운다 — wiring.filterFallback 슬롯(값이 있는 키는 덮지 않는다)
    if (!wiring.filterFallback?.sy07FilterCard) return
    setFlSy07FilterCard((s) => { const patch = wiring.filterFallback?.sy07FilterCard?.(s, { SY07SHIPPER_OPTIONS }); if (!patch) return s; let n = s; Object.entries(patch).forEach(([k, v]) => { const c = s[k]; if (c === undefined || c === '' || (Array.isArray(c) && c.length === 0)) { if (n === s) n = { ...s }; n[k] = v } }); return n })
  }, [SY07SHIPPER_OPTIONS, flSy07FilterCardReset])
  // 페이저 ↔ 표 짝(pagerKey 'pager') — 액션바 페이저가 페이지를 소유하고 표는 그 페이지만 그린다. '몇 개씩' 미노출 = 10,000개씩(MOMS·MWMS 공통 규칙 2026-08-24).
  const [pgPager, setPgPager] = useState(() => ({ page: wiring.stateInitial?.pager?.pager?.page ?? 1, size: wiring.stateInitial?.pager?.pager?.size ?? 10000 })) // 진입 초기값 = wiring.stateInitial(예: URL 복원)
  const [stListq_table_q, setStListq_table_q] = useState(wiring.stateInitial?.listq?.["table.q"] ?? '') // 토글 상태(스토어 키 'listq:table.q')
  const ROWS_R = wiring.rows.ROWS(ROWS_DEMO, { filters: flSy07FilterCard, pager: pgPager }) // 표 데이터 — wiring.ts 슬롯(인자 = 데모 목데이터·조회 조건·페이저)
  const ROWS = Array.isArray(ROWS_R) ? ROWS_R : ROWS_R.rows
  const ROWS_CL = wiring.columnLayout?.sy07Table?.(COLUMNS) // 컬럼 배치(순서·너비·고정·숨김) — 없으면 표 내부 상태
  const ROWS_TOTAL = Array.isArray(ROWS_R) ? ROWS.length : (ROWS_R.total ?? ROWS.length)
  // [목록 검색] 표시 컬럼 전체 부분일치(대소문자 무시) — 어댑터 TableRender listQ 규약. 확정은 검색칸 엔터/돋보기(onSearch).
  const ROWSListed = useMemo(() => {
    const q = stListq_table_q.trim().toLowerCase()
    if (!q) return ROWS
    const idx = COLUMNS.map((c) => c.dataIndex).filter((d): d is string => typeof d === 'string')
    const hit = (x: Record<string, unknown>) => idx.some((di) => String((x[di] ?? '') as string | number).toLowerCase().includes(q))
    return ROWS.flatMap((r) => {
      const kids = Array.isArray(r.children) ? (r.children as Record<string, unknown>[]) : undefined
      if (kids) { const kept = kids.filter(hit); if (kept.length) return [{ ...r, children: kept }]; return hit(r) ? [{ ...r, children: [] }] : [] }
      return hit(r) ? [r] : []
    })
  }, [stListq_table_q, ROWS])
  visRef.current = ROWSListed // 액션 슬롯 ctx.visible — 목록 검색 뒤 보이는 행
  const ROWS_SERVERPAGED = !Array.isArray(ROWS_R) && ROWS_R.total != null // total 을 준 쪽이 서버 페이징
  const ROWS_PG = ROWS_SERVERPAGED ? pgPager.page : Math.min(pgPager.page, Math.max(1, Math.ceil(ROWSListed.length / pgPager.size))) // 건수가 줄어 지금 페이지가 범위를 넘으면 마지막 페이지를 그린다(옛 손코드 pageNo clamp — 목록 검색·업로드·삭제 뒤 빈 표 방지). 페이저 표시·onState 도 이 값(상태는 그대로 — 복원한 페이지를 로딩 중 0건으로 잃지 않는다)
  const ROWS_PAGE = ROWS_SERVERPAGED ? ROWSListed : ROWSListed.slice((ROWS_PG - 1) * pgPager.size, ROWS_PG * pgPager.size)
  useEffect(() => { document.body.classList.add('pbo-screen-portal'); return () => { document.body.classList.remove('pbo-screen-portal') } }, [])
  useEffect(() => { selReset.current = () => setStSelEpoch((n) => n + 1); return () => { selReset.current = () => {} } }, []) // 확인창 성공 뒤 선택 비움
  useEffect(() => { wiring.onState?.({ pager: { "pager": { ...pgPager, page: ROWS_PG } }, listq: { "table.q": stListq_table_q } }) }, [pgPager, ROWS_PG, stListq_table_q]) // 화면 상태 → 배선(URL/세션 persist)
  useEffect(() => { origRows.set("ROWS", ROWS); return () => { origRows.delete("ROWS") } }, [ROWS]) // 문구 토큰의 원본 행(fillTok)
  return (
    <core.ConfigProvider theme={pboLogisticsTheme}>
      <div className="pbo-core-screen pbo-screen-shell pbo-fonts">
        {/* #commonCode CommonCodePage */}
        <core.Flex vertical gap={16} align="stretch">
          {/* #workspaceTab WorkspaceTab */}
          <core.WorkspaceTab style={{ margin: "-24px -24px 0px -24px" }} activeLabel="코드관리" />
          {/* ▼ 그룹 cmp.TitleRow #sy07Title — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
          {/* #sy07Title:titleRowDef TitleRow */}
          <core.Flex gap={8} justify="space-between" align="center" ref={hdrsy07Title_titleRowDef.ref} className={`dev-page-header-wrap pin${hdrsy07Title_titleRowDef.isSticky ? ' sticky' : ''}`} style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: 'auto', minHeight: 40, top: 'calc(12px - var(--pbo-page-header-scroller-pad, 0px))', ['--pbo-page-header-bleed-top' as string]: '36px' }}>
            {/* #sy07Title:pageTitle PageTitle */}
            <core.Typography.Title level={4} style={{ margin: 0, whiteSpace: 'pre-line' }}>코드관리</core.Typography.Title>
            {/* #sy07Title:titleRight TitleRight */}
            <core.Flex gap={16} align="center">{null}</core.Flex>
          </core.Flex>
          {/* ▲ 그룹 cmp.TitleRow #sy07Title 끝 */}
          {/* ▼ 그룹 cmp.FilterCard #sy07FilterCard — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
          {/* #sy07FilterCard:filterCardDef FilterCard */}
          <core.Card styles={{ body: { padding: "12px 20px" } }} style={{ border: '1px solid #d9d9d9', borderRadius: 8, minWidth: 0 }}>
            {/* #sy07FilterCard:filterBody FilterBody */}
            <div className={`${flSy07FilterCardCollapsed ? 'pbo-filter-collapse-closed' : 'pbo-filter-collapse-open'}`}>
              {flSy07FilterCardCollapsed && <span className="pbo-filter-empty-msg">필터가 적용된 항목이 없어요. 필터를 열어 원하는 조건으로 검색해 보세요.</span>}
              {/* #sy07FilterCard:filterFields FilterFields */}
              <core.Flex gap={20} align="flex-start" wrap>
                {/* ▼ 그룹 cmp.FilterField #sy07Shipper — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
                {/* #sy07Shipper:filterFieldDef FilterField */}
                <FilterField collapsed={flSy07FilterCardCollapsed} label="화주명" required chip={chipSelect(SY07SHIPPER_OPTIONS, flSy07FilterCard.SPR_NM ?? "무신사스탠다드", true)} fieldKey="sy07Shipper:filterFieldDef" onOpen={() => setFlSy07FilterCardCollapsed(false)}>
                  {/* #sy07Shipper:control Control */}
                  <core.Select placement="bottomLeft" builtinPlacements={POPUP_DOWN} className="pbo-filter-select" showSearch optionFilterProp="label" options={SY07SHIPPER_OPTIONS} disabled={wiring.filterDisabled?.SPR_NM} value={(flSy07FilterCard.SPR_NM as string | undefined) ?? "무신사스탠다드"} onChange={(v) => setFlSy07FilterCard((s) => ({ ...s, SPR_NM: v }))} placeholder="화주명을(를) 선택해주세요." style={{ width: '100%' }} />
                </FilterField>
                {/* ▲ 그룹 cmp.FilterField #sy07Shipper 끝 */}
                {/* ▼ 그룹 cmp.FilterField #sy07CodeGrp — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
                {/* #sy07CodeGrp:filterFieldDef FilterField */}
                <FilterField collapsed={flSy07FilterCardCollapsed} label="코드그룹" chip={chipText(flSy07FilterCard.CODE_GRP)} fieldKey="sy07CodeGrp:filterFieldDef" onOpen={() => setFlSy07FilterCardCollapsed(false)}>
                  {/* #sy07CodeGrp:control Control */}
                  <core.Input placeholder="코드그룹 입력" value={(flSy07FilterCard.CODE_GRP as string | undefined) ?? ''} onChange={(e) => setFlSy07FilterCard((s) => ({ ...s, CODE_GRP: e.target.value }))} style={{ width: '100%' }} />
                </FilterField>
                {/* ▲ 그룹 cmp.FilterField #sy07CodeGrp 끝 */}
                {/* ▼ 그룹 cmp.FilterField #sy07Code — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
                {/* #sy07Code:filterFieldDef FilterField */}
                <FilterField collapsed={flSy07FilterCardCollapsed} label="코드" chip={chipText(flSy07FilterCard.CODE)} fieldKey="sy07Code:filterFieldDef" onOpen={() => setFlSy07FilterCardCollapsed(false)}>
                  {/* #sy07Code:control Control */}
                  <core.Input placeholder="코드 입력" value={(flSy07FilterCard.CODE as string | undefined) ?? ''} onChange={(e) => setFlSy07FilterCard((s) => ({ ...s, CODE: e.target.value }))} style={{ width: '100%' }} />
                </FilterField>
                {/* ▲ 그룹 cmp.FilterField #sy07Code 끝 */}
              </core.Flex>
              {/* #sy07FilterCard:filterFooter FilterFooter */}
              <core.Flex gap={8} justify="flex-end" align="center">
                {/* #sy07FilterCard:filterToggleButton FilterToggleButton */}
                <core.Button icon={flSy07FilterCardCollapsed ? <DownOutlined /> : <UpOutlined />} onClick={() => setFlSy07FilterCardCollapsed((c) => !c)}>{`필터 ${flSy07FilterCardCollapsed ? '열기' : '닫기'}`}</core.Button>
                {/* #sy07FilterCard:filterFooterDivider FilterFooterDivider */}
                <span style={{ height: 18, margin: '0 0px', borderLeft: '1px solid #d9d9d9', display: 'block', flex: 'none' }} />
                {/* #sy07FilterCard:resetButton ResetButton */}
                {permCan('CLEAR') && <core.Button onClick={() => { setFlSy07FilterCard(flSy07FilterCardDefaults); setFlSy07FilterCardReset((t) => t + 1); setPgPager((s) => (s.page === 1 ? s : { ...s, page: 1 })); setStSelEpoch((n) => n + 1); setStListq_table_q(''); wiring.onReset?.() }}>초기화</core.Button>}
                {/* #sy07FilterCard:searchButton SearchButton */}
                {permCan('SEARCH') && <core.Button type="primary" onClick={() => { Promise.resolve(wiring.actions.search(flSy07FilterCard)).then((r) => { if (r === false) return; setPgPager((s) => (s.page === 1 ? s : { ...s, page: 1 })); setStSelEpoch((n) => n + 1); setStListq_table_q(''); }, () => undefined) }}>조회</core.Button>}
              </core.Flex>
            </div>
          </core.Card>
          {/* ▲ 그룹 cmp.FilterCard #sy07FilterCard 끝 */}
          {/* ▼ 그룹 cmp.TableGroup #tableGroup — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
          {/* #tableGroup:tableGroupDef TableGroup */}
          <core.TableSelectionScope key={stSelEpoch}><SelBridge scope="tableGroup" />
            {/* #tableGroup:tableGroupInner TableGroupInner */}
            <core.Flex vertical gap={8} align="stretch">
              {/* #tableGroup:tableHeader TableHeader */}
              <core.Flex style={{ padding: "4px 0px 4px 0px" }} gap={8} justify="space-between" align="center" className="pbo-v2-actionbar-sticky">
                {/* #tableGroup:toolbarLeft ToolbarLeft */}
                <core.Space>
                  {/* #sy07TableStat TableStat */}
                  <SelStat total={ROWS_TOTAL} />
                  {/* #sy07SaveButton SaveButton */}
                  {permCan('SAVE') && <SelGatedButton type="primary" onClick={() => { if (wiring.opens?.sy07SaveButton?.(selCtx()) === false) return; confirmsy07SaveConfirm() }}>저장</SelGatedButton>}
                  {/* #sy07DeleteButton DeleteButton */}
                  {permCan('DELETE') && <SelGatedButton onClick={() => { if (wiring.opens?.sy07DeleteButton?.(selCtx()) === false) return; confirmsy07DeleteConfirm() }}>삭제</SelGatedButton>}
                </core.Space>
                {/* #tableGroup:toolbarRight ToolbarRight */}
                <core.Space>
                  {/* #tableGroup:tablePager TablePager */}
                  <core.TablePager variant="paged" page={ROWS_PG} pageSize={pgPager.size} total={(stListq_table_q.trim() ? ROWSListed.length : ROWS_TOTAL)} showSizeChanger={false} onPage={(page, size) => { if (wiring.canChangePage?.({ pager: "pager", page, size }) === false) return; setStSelEpoch((n) => n + 1); setStListq_table_q(''); setPgPager({ page: size !== pgPager.size ? 1 : page, size }) }} />
                  {/* #tableGroup:listSearch ListSearch */}
                  <core.Input.Search placeholder="목록 검색" allowClear key={stSelEpoch} style={{ width: 240 }} defaultValue={stListq_table_q} onSearch={(v) => setStListq_table_q((v ?? '').trim())} />
                  {/* #tableGroup:toolbarDivider2 Divider */}
                  <span style={{ height: 18, margin: '0 4px', borderLeft: '1px solid #d9d9d9', display: 'block', flex: 'none' }} />
                  {/* #sy07AddButton AddButton */}
                  {permTool('add', 'sy07Table') && <core.Button icon={<DsIcon name="ic-plus" size={16} color="currentColor" />} onClick={() => { wiring.actions.sy07AddButton({ ...selCtx(), table: "ROWS", defaults: {} }); }}>추가</core.Button>}
                </core.Space>
              </core.Flex>
              {/* #sy07Table Table */}
              <EditSelTable columns={permCols(COLUMNS, 'sy07Table')} dataSource={ROWS_PAGE.map((r, i) => ({ key: i, ...r }))} loading={Array.isArray(ROWS_R) ? undefined : ROWS_R.loading} rowSelection={{ type: "checkbox", columnWidth: 48, fixed: true }} stickyOffset={104} size="middle" scroll={{ x: 'max-content' }} onRowsChange={(next) => wiring.actions.ROWS_rowsChange(next as Record<string, unknown>[])} columnOrder={ROWS_CL?.columnOrder} onColumnOrderChange={ROWS_CL?.onColumnOrderChange} columnWidths={ROWS_CL?.columnWidths} onColumnWidthsChange={ROWS_CL?.onColumnWidthsChange} pinnedColumns={ROWS_CL?.pinnedColumns} onPinnedColumnsChange={ROWS_CL?.onPinnedColumnsChange} hiddenColumns={ROWS_CL?.hiddenColumns} onHiddenColumnsChange={ROWS_CL?.onHiddenColumnsChange} />
            </core.Flex>
          </core.TableSelectionScope>
          {/* ▲ 그룹 cmp.TableGroup #tableGroup 끝 */}
          {/* 컨펌 모달 confirmsy07SaveConfirm() — opens=sy07SaveConfirm 인 버튼이 호출한다(codegen 배선). */}
          {/* 컨펌 모달 confirmsy07DeleteConfirm() — opens=sy07DeleteConfirm 인 버튼이 호출한다(codegen 배선). */}
        </core.Flex>
      </div>
    </core.ConfigProvider>
  )
}
